import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "ef-layoutIN" }

import Sidenav from "@/components/Sidenav.vue";
import {storeSystem} from "@/stores/system";
import {storeToRefs} from "pinia";
import {onMounted, ref} from "vue";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const _storeSystem = storeSystem();

const {isModaleOpen} = storeToRefs(_storeSystem);

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Sidenav),
    _createElementVNode("div", {
      class: _normalizeClass(['ef-layoutIN__wrapper', { '-blur' : _unref(isModaleOpen) }])
    }, [
      _createVNode(_component_router_view)
    ], 2)
  ]))
}
}

})